module.exports = __webpack_public_path__ + "img/asus-zenbook-ux410ua.8c7e6677.jpg";